export default {
  SET_GOOGLE_SHEETS_SYNC: function (state, payloads) {
    state.googleSheets = payloads;
  }
}
